module.exports = __webpack_public_path__ + "img/icon02.b638fe09.png";